import { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import Navbar from "../components/Navbar";
import { CalendarInput } from "../components/FormComps";
import Pagination , { PagiSearch } from "../components/Pagination";
import { convertToISO, dateInNumbers, getApiSetting, postApiSetting } from "../assets/functions";
  import { ToastContainer, toast } from 'react-toastify';
  import { NavLink,useNavigate } from "react-router-dom";
export default function PayinWalletReport ( {setAuth} ) {

    const navigate = useNavigate();
    const fromDateRef = useRef(null);
    const toDateRef = useRef(null);

    const [transactinoData, setTransactinoData] = useState([]);
    const [dataFilter, setDataFilter] = useState([]);
    const [startOffset, setStartOffset] = useState(0);
    const [search, setSearch] = useState('');
    const [tableDataStatus, setTableDataStatus] = useState('');
    const [totalDebitAmount, setTotalDebitAmount] = useState(0);
    const [totalCreditAmount, setTalCreditAmount] = useState(0);

    const itemsPerPage = 10;
    const searchData = transactinoData.filter(item => Object.values(item).join("").toString().toLowerCase().includes(search.toLowerCase()))
    const endOffset = startOffset + itemsPerPage;
    const currentItems = searchData.slice(startOffset, endOffset)
    const pageCount = Math.ceil(searchData.length / itemsPerPage)

    useEffect(()=>{
        setTableDataStatus('Loading...');
        (async()=>{
            try {
                let res = await fetch('/Admin/api/Admin/reportDataWallet', getApiSetting());
                let result = (res.status === 200) ? await res.json(): "";
                console.log("result--",result)
                if(res.status === 200){
                    if(result.data.length < 1){
                        setTableDataStatus('Not Found')
                    }else{
                        let data = result.data.sort(function(a, b) {
                            let c = new Date(convertToISO(a.txnDateTime));
                            let d = new Date(convertToISO(b.txnDateTime));
                            return d-c;
                        })
                        setTableDataStatus('')
                        setTransactinoData(data)
                        setDataFilter(data)
                    }
                }
                else if(res.status === 401)
                {
                    setAuth(false)
                    toast.error(result.data.responseMsg, {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
                
            } catch (error) {
                console.log(error)
            }
        })()
    },[])

    const searchTransactions = async () => {
        let fDate = fromDateRef.current.value;
        let tDate =  toDateRef.current.value;
        if(!fDate || !tDate) {
            alert('Report date are required.')
            return false;
        }
        setTableDataStatus('Loading...')
        setTransactinoData([])
        setDataFilter([])
        let postSetting = postApiSetting({fDate,tDate})
        let res = await fetch('/Admin/api/Admin/reportDataByDateWallet', postSetting);
        let result = (res.status === 200) ? await res.json(): "";
    
        if(res.status !== 200){
            alert('something went wrong : '+ res.status)
        }else{
            if(result.data.length < 1){
                setTableDataStatus('Not Found');
            }else{
                let data = result.data.sort(function(a, b) {
                    let c = new Date(convertToISO(a.txnDateTime));
                    let d = new Date(convertToISO(b.txnDateTime));
                    return d-c;
                })
                setTableDataStatus('');
                setTransactinoData(data)
                setDataFilter(data)
            }
        }
    }

    const changeHandler = () => {
        let countries = document.querySelectorAll('.fts_filter input');
        let choices = [];
        countries.forEach(item => item.checked ? choices.push(item.value) : '')
        let filteredArray = dataFilter.filter(item => choices.length > 0 ? choices.includes(item.status) : item);
        // console.log(dataFilter)
        // console.log(filteredArray)
        setTransactinoData(filteredArray)
        if (filteredArray.length < 1) setTableDataStatus('Not Found')
    }

    const downloadReport = () => {
        // let data = searchData.map((item) => {
            // return {...item, 
            //     payAmount:(item.payAmount/100).toString(), 
            //     requestAmount:(item.requestAmount/100).toString()
            // }
            // return{
                // let availableBalance = 0
                // item.availableBalance= availableBalance/100
            // }
            
        // })
        let data = searchData
        let date = dateInNumbers();
        let workbook = XLSX.utils.book_new();
        let worksheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, "WalletReport");
        XLSX.writeFile(workbook, `WalletReport_${date}.xlsx`);
    }
    useEffect(()=>{
        if(searchData.length > 0){
          let totalcrAmt = searchData.map((item)=> parseFloat(item.creditAmount/100) ).reduce((a,b)=>a+b).toFixed(2);
          let totaldbAmt = searchData.map((item)=> parseFloat(item.debitAmount/100) ).reduce((a,b)=>a+b).toFixed(2);
          setTotalDebitAmount(totalcrAmt)
          setTalCreditAmount(totaldbAmt)
        }else{
            setTotalDebitAmount(0)
            setTalCreditAmount(0)
        }
    },[searchData])
    return (<>
        {/* <SidebarNavigation /> */}
        <section className="transaction-page">
            <Navbar title="TRANSACTIONS" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <h6 className="mb-3">Wallet Report</h6>
                    <form className="mb-4">
                        <div className="row">
                            <div className="col-sm-2">
                                <CalendarInput dateRef={fromDateRef} />
                            </div>
                            <div className="col-sm-2">
                                <CalendarInput dateRef={toDateRef} />
                            </div>
                            <div className="col-sm-3">
                                <button type="button" className="btn btn-sm _themebg-0 text-white me-3" onClick={searchTransactions}>
                                <i className="fa-solid fa-magnifying-glass"></i> Search</button>
                                <button type="button" className="btn btn-sm _themebg-0 text-white me-3" onClick={downloadReport}>
                                <i className="fa-solid fa-file-arrow-down pe-1"></i>Download</button>
                            </div>
                        </div>
                    </form>

                    <ul className="list-group list-group-horizontal-md mb-3 mt-2 fts_filter">
                        <li className="list-group-item">
                            <div className="form-check">
                                <input className="form-check-input check-bg" type="checkbox" id='txnfltrcheck1' value='Pending For Authorization' onChange={changeHandler} />
                                <label className="form-check-label" htmlFor='txnfltrcheck1'>PENDING</label>
                            </div>
                        </li>
                        <li className="list-group-item">
                        <div className="form-check">
                                <input className="form-check-input check-bg" type="checkbox" id='txnfltrcheck2' value='Transaction Failed' onChange={changeHandler} />
                                <label className="form-check-label" htmlFor='txnfltrcheck2'>FAILED</label>
                            </div>
                        </li>
                        <li className="list-group-item">
                        <div className="form-check">
                                <input className="form-check-input check-bg" type="checkbox" id='txnfltrcheck3' value='Transaction Successful' onChange={changeHandler} />
                                <label className="form-check-label" htmlFor='txnfltrcheck3'>SUCCESS</label>
                            </div>
                        </li>
                        <li className="list-group-item">
                        <div className="form-check">
                                <input className="form-check-input check-bg" type="checkbox" id='txnfltrcheck4' value='Transaction Initiated' onChange={changeHandler} />
                                <label className="form-check-label" htmlFor='txnfltrcheck4'>INITIATED</label>
                            </div>
                        </li>
                    </ul>            

                    <PagiSearch setSearch={setSearch}
                    totalEntries={searchData.length}
                    setStartOffset={setStartOffset}
                    setTableDataStatus={setTableDataStatus} 
                    totalCreditAmount={totalCreditAmount}
                    totalDebitAmount={totalDebitAmount}
                     />

                    <div className="table-responsive my-2 com-table">
                    <table className="table table-bordered mb-1">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>mid</th>
                                <th>User Id</th>
                                <th>Wallet Id</th>
                                <th>Order No</th>
                                <th>Txn Ref Id</th>
                                <th>Request Initiated Date & Time</th>
                                <th>PayMode</th>
                                <th>PayMode Category</th>
                                <th>Txn Type</th>
                                <th>Debit Amount</th>
                                <th>Credit Amount</th>
                                <th>Previous Balance</th>
                                <th>Available Balance</th>
                                <th>Status</th>
                                <th>Status Code</th>
                                <th>Payin Order No</th>
                                <th>Payin Txn Id</th>
                                <th>Txn Date & Time</th>
                                <th>Rrn</th>
                                <th>Remarks</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length < 1 ? <tr><td colSpan={11}><h6>{tableDataStatus}</h6></td></tr> : 
                            currentItems.map((item,index) => {
                               
                                return (
                                <tr key={index}>
                                    <td>{startOffset + index + 1}</td>
                                    <td>{item.mid}</td>
                                    <td>{item.userId}</td>
                                    <td>{item.walletId}</td>
                                    <td>{item.orderId}</td>
                                    <td>{item.txnRefId}</td>
                                    <td>{item.reqestInitiatedDateTime}</td>
                                    <td>{item.paymode}</td>
                                    <td>{item.paymodeCategory}</td>
                                    <td className={item.txnType==='C'?'text-success  fw-bold text-center':'text-center text-danger fw-bold'} >{item.txnType==='C'?'Cr':'Dr'}</td>
                                    <td>{item.debitAmount/100}</td>
                                    <td>{item.creditAmount/100}</td>
                                    <td>{item.previousBalance/100}</td>
                                    <td>{item.availableBalance/100}</td>
                                    <td>{item.status}</td>
                                    <td>{item.statusCode}</td>
                                    <td>{item.payinOrderNo}</td>
                                    <td>{item.payinTxnId}</td>
                                    <td>{item.txnDateTime}</td>
                                    <td>{item.rrn}</td>
                                    <td>{item.remarks}</td>
                                </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    </div>

                    <Pagination setStartOffset={setStartOffset}
                    pageCount={pageCount} itemsPerPage={itemsPerPage} />

                </div>
            </div>
        </section>
    </>)
}